import { stringify } from 'query-string'
import { GetListParams, GetOneParams } from 'react-admin'
import axios from 'axios'

import { DEFAULT_SORT_FIELD, DEFAULT_SORT_ORDER, LEARNING_SERVICE_ENDPOINT } from 'utils/constants'

class SourceSystemProvider {
  public baseUrl: string

  public constructor() {
    this.baseUrl = LEARNING_SERVICE_ENDPOINT
  }

  public getList = async (resource: string, params: GetListParams) => {
    const { page, perPage } = params.pagination
    const { field = DEFAULT_SORT_FIELD, order = DEFAULT_SORT_ORDER } = params.sort

    const query = {
      ...params.filter,
      skip: (page - 1) * perPage,
      limit: perPage,
      field,
      order,
    }

    const url = `${this.baseUrl}/${resource}/?${stringify(query)}`

    return axios
      .get(url)
      .then(response => {
        const { data, count: total } = response.data

        if (!data) {
          Promise.reject()
        }

        return Promise.resolve({
          data,
          total,
        })
      })
      .catch(err => Promise.reject(err))
  }

  public getOne = async (resource: string, params: GetOneParams) => {
    const url = `${this.baseUrl}/${resource}/${params.id}`

    return axios
      .get(url)
      .then(response => {
        const { data, count: total } = response.data

        if (!data) {
          Promise.reject()
        }

        return Promise.resolve({
          data,
          total,
        })
      })
      .catch(err => Promise.reject(err))
  }
}

export default SourceSystemProvider
